var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":""}},[_c('ul',{staticClass:"newListTab fl"},_vm._l((_vm.listTabData),function(item,idx){return _c('li',{key:idx,class:{'active':_vm.isActive === idx},on:{"click":function($event){return _vm.tabClick(idx, item.id)}}},[_vm._v(_vm._s(item.title))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86cdb8da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/newsListTab.vue
// module id = null
// module chunks = 